import type { AppRouteModule } from '@/router/types';

import { LAYOUT } from '@/router/constant';
import { RoleEnum } from '@/enums/roleEnum';

const Business: AppRouteModule = {
  path: '/sales',
  name: 'Sales',
  identify: 'sales',
  component: LAYOUT,
  redirect: '/sales/salesRewardApply',
  meta: {
    icon: 'foundation:burst-sale',
    title: '销量提报',
    roles: [RoleEnum.OFFLINE],
  },
  children: [
    {
      path: 'salesRewardApply',
      name: 'SalesRewardApply',
      identify: 'sales_reward_apply_list',
      component: () => import('@/views/sales/salesRewardApply/index.vue'),
      meta: {
        title: '报量列表',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'salesRewardDetail',
      name: 'SalesRewardDetail',
      identify: 'sales_reward_detail_list',
      component: () => import('@/views/sales/salesRewardDetail/index.vue'),
      meta: {
        title: '奖励明细',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'salesRewardStatistics',
      name: 'SalesRewardStatistics',
      identify: 'sales_reward_statistics_list',
      component: () => import('@/views/sales/salesRewardStatistics/index.vue'),
      meta: {
        title: '奖励统计',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'salesRewardStatistics/detail',
      name: 'SalesRewardStatisticsDetail',
      identify: 'sales_reward_statistics_detail',
      component: () => import('@/views/sales/salesRewardStatistics/details.vue'),
      meta: {
        title: '奖励统计详情',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/sales/salesRewardStatistics',
        roles: [RoleEnum.OFFLINE],
      },
    },
  ],
};

export default Business;
